import 'leaflet';
import 'leaflet.markercluster';

const { L } = window;

const location = () => {
  const maps = document.querySelectorAll('[data-location-map]');
  if (maps.length) {
    maps.forEach(map => {
      const mapData = JSON.parse(map.dataset.locationMapMarker);
      const bounds = [];

      const leafletMap = L.map(map.id, {
        scrollWheelZoom: false,
        zoomControl: false,
        maxZoom: 14,
      });

      leafletMap.touchZoom.disable();
      leafletMap.doubleClickZoom.disable();
      leafletMap.scrollWheelZoom.disable();
      leafletMap.boxZoom.disable();
      leafletMap.keyboard.disable();

      L.control
        .zoom({
          position: 'bottomleft',
        })
        .addTo(leafletMap);

      const markers = L.markerClusterGroup({
        showCoverageOnHover: false,
      });

      // eslint-disable-next-line no-unused-vars
      mapData.forEach((item, index) => {
        if (item.lat && item.lng) {
          bounds.push([item.lat, item.lng]);

          let markerColor = '#18BAE5';
          if (item.marker_color) {
            markerColor = item.marker_color;
          }

          const MarkerIcon = L.divIcon({
            className: 'c-map__marker',
            iconSize: [12, 12],
            iconAnchor: [6, 12],
            popupAnchor: [0, 0],
            html: `<div class="c-map__marker-dot" style="background: ${markerColor}"></div>`,
          });


          const marker = L.marker([item.lat, item.lng], {
            icon: MarkerIcon,
          });

          const popupLink = document.getElementById(`location-${item.id}`)

          if(popupLink) {
            const popup = L.popup({
              className: `c-map__popup`,
              closeButton: false,
            })
              .setLatLng([item.lat, item.lng])
              .setContent(
                popupLink.cloneNode(true),
              );

            marker.bindPopup(popup).openPopup();

          }

          // .addTo(leafletMap);
          markers.addLayer(marker);
        }
      });

      leafletMap.addLayer(markers);

      leafletMap.on('popupopen', e => {
        // eslint-disable-next-line no-underscore-dangle
        e.popup._source._icon.classList.add('c-map__marker--active');
      });

      leafletMap.on('popupclose', e => {
        // eslint-disable-next-line no-underscore-dangle
        e.popup._source._icon.classList.remove('c-map__marker--active');
      });

      if (bounds.length) {
        leafletMap.fitBounds(bounds);
      }

      leafletMap.attributionControl.setPrefix('');
      L.tileLayer(
        'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=cb1_2ap6_1_a4be8fb67fb2c23cc459ec41',
        {
          attribution:
            'Map tiles by Carto, under CC BY 3.0. Data by &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, under ODbL.',
        },
      ).addTo(leafletMap);
    });

    // eslint-disable-next-line no-undef
    if (FWP.loaded) {
      document.querySelector('.facetwp-template').classList.add('visible');
    }
  }
};
location();
document.addEventListener('facetwp-loaded', () => location());
